import { useGlobal } from '@/utils/useGlobal';
import EmailSubscribe, { PAGE_TYPE } from '@elem/compCommon/EmailSubscribe';
import SideMenu, { SideMenuProps } from '@elem/compCommon/SideMenu';
import { createPortal } from 'react-dom';
import B from './components/B';
import C from './components/C';
import FreeQuote from './components/FreeQuote';
import J from './components/J';
import K from './components/K';
import L from './components/L'; // 暂未获得授权，临时取消上线
import M from './components/M';
import N from './components/N';
import Preparing from './components/Preparing';
import { PAGE_LINK } from './components/Preparing/data';
import R from './components/R';

export default function IndexDynamic() {
    const { useState, useLang, useEffect, useRouter } = useGlobal();
    const { locale } = useRouter();
    const [isClient, setIsClient] = useState(false);
    const { t } = useLang('powerbackup');
    const obj: SideMenuProps = {
        items: [
            { text: t('secD_btn1'), link: PAGE_LINK.E },
            { text: t('secD_btn2'), link: PAGE_LINK.F },
            { text: t('secD_btn3'), link: PAGE_LINK.G },
            ...(locale === 'us' ? [{ text: t('secD_btn4'), link: PAGE_LINK.H }] : []),
        ],
    };

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    return (
        <>
            {['us'].includes(locale as string) && isClient && createPortal(<FreeQuote />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
            <B />
            <C />
            <Preparing obj={obj} />
            <EmailSubscribe locale={locale} className="email-subscribe" pageType={PAGE_TYPE.BatteryBackupForHome} entry_position={6} />
            <J />
            <K />
            <L />
            <M />
            <N />
            {isClient && createPortal(<SideMenu items={obj.items} />, document.querySelector('#Widgets-box-in2-right-id') || document.body)}
            {locale === 'us' && <R />}
        </>
    );
}
